import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import StartProjectPage from "@/pages/StartProjectPage";
import BusinessAssistancePage from "@/pages/BusinessAssistancePage";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/start-your-project" element={<Layout><StartProjectPage /></Layout>} />
          <Route path="/business-assistance" element={<Layout><BusinessAssistancePage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
          <Route path="/services"  element={<Navigate to="/#services"  replace />} />
          <Route path="/prices"    element={<Navigate to="/#packages"  replace />} />
          <Route path="/portfolio" element={<Navigate to="/#featured"  replace />} />
          <Route path="/about"     element={<Navigate to="/#top"       replace />} />
          <Route path="/contact"   element={<Navigate to="/#contact"   replace />} />
          <Route path="/admin"     element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}

export default App;

